import Marionette from "backbone.marionette";
import InsertTpl from "views/instances/insertInstanceView.ejs";

import BDateCSS from "../../../node_modules/eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.min.css";
import BDate from "eonasdan-bootstrap-datetimepicker";

import S from "session/session.js";
import T from "session/token.js";

export default Marionette.View.extend({
    template: InsertTpl,
    render: function() {
        $('.content-wrapper').css({ 'margin-left': '230px' });
        this.$el.html(this.template({
            attributes: this.model.attributes,
            lang: this.collection.lang
        }));
        $("#insertModal").modal('show');
    },
    onShow: function() {
        $("#dtpickerStart").datetimepicker({
            format: 'DD/MM/YYYY'
        });
        $("#dtpickerEnd").datetimepicker({
            format: 'DD/MM/YYYY'
        });
    },
    events: {
        "submit #insertInstanceForm": "save",
        "click #cancel": "cancel"
    },
    save: function(ev) {

        $("#loaderContainer").show();
        ev.preventDefault();
        var formData = {};
        _.each(ev.target.elements, function(element) {
            if (element.nodeName === "BUTTON")
                return;

            if ($(element).attr("type") === "file")
                return;

            if ($(element).val() === "on") {
                formData[$(element).attr("id")] = 1;
                return;
            }

            if ($(element).hasClass("date")) {
                var fecha = $(element).val().split("/");
                formData[$(element).attr("id")] = fecha[2] + "-" + fecha[1] + "-" + fecha[0];
                return;
            }

            formData[$(element).attr("id")] = $(element).val();
        });

        formData.company = S.companyId;

        var reader = new FileReader(),
            file = $('#icon')[0];

        //File upload
        if ($(file).val()) {
            reader.readAsDataURL(file.files[0]);

            reader.onload = function() {

                var data = reader.result;
                formData.icon = data;
                formData.EfileName = $(file).val();

                this.model.save(formData, {
                    beforeSend: T.useToken,
                    success: function() {
                        $("#loaderContainer").hide();
                        S.mApp.trigger("notify:success", {
                            message: S.userInfo.attributes.lang.INSERT_OK
                        });
                        S.mApp.trigger("update:instances");
                        $("#insertModal").modal('hide');
                    },
                    error: function() {
                        $("#loaderContainer").hide();
                        S.mApp.trigger("notify:error", {
                            message: S.userInfo.attributes.lang.INSERT_ERROR
                        });
                        $("#insertModal").modal('hide');
                    }
                });
            }.bind(this);
        } else {
            this.model.save(formData, {
                beforeSend: T.useToken,
                success: function() {
                    $("#loaderContainer").hide();
                    S.mApp.trigger("notify:success", {
                        message: S.userInfo.attributes.lang.INSERT_OK
                    });
                    S.mApp.trigger("update:instances");
                    $("#insertModal").modal('hide');
                },
                error: function() {
                    $("#loaderContainer").hide();
                    S.mApp.trigger("notify:error", {
                        message: S.userInfo.attributes.lang.INSERT_ERROR
                    });
                    $("#insertModal").modal('hide');
                }
            });
        }
        /* else {
            $("#insertModal").modal('hide');
            $("#loaderContainer").hide();

            S.mApp.trigger("notify:error", {
                message: S.userInfo.attributes.lang.ERRIMAGE
            });
        } */



        return false;
    },
    cancel: function() {
        $("#insertModal").modal("hide");
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/views/instances/insertInstanceView.js
// module id = 186
// module chunks = 0